import { BlockStack, Card, InlineStack, Text, Tooltip } from '@shopify/polaris'
import { ReactElement } from 'react'

function OverviewCard(props: {
  children: ReactElement | ReactElement[]
  title?: string
  tooltip?: { enabled: boolean; title?: string; body?: string | ReactElement }
  primaryAction?: ReactElement
}): JSX.Element {
  return (
    <Card roundedAbove="sm">
      <BlockStack gap={'200'}>
        {props.title && (
          <InlineStack align="space-between">
            {props.tooltip?.enabled ? (
              <Tooltip
                content={
                  <BlockStack gap="100">
                    <Text as="h2" variant="headingMd">
                      {props.tooltip?.title}
                    </Text>
                    <Text as="span" variant="bodyMd">
                      {props.tooltip?.body}.
                    </Text>
                  </BlockStack>
                }
                hasUnderline={true}
                dismissOnMouseOut={true}
              >
                <Text as="h2" variant="headingMd">
                  {props.title}
                </Text>
              </Tooltip>
            ) : (
              <Text as="h2" variant="headingMd">
                {props.title}
              </Text>
            )}
            {props.primaryAction ?? <></>}
          </InlineStack>
        )}
        {props.children}
      </BlockStack>
    </Card>
  )
}

export default OverviewCard
